var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0297 6.77578C19.5884 5.75831 18.9523 4.83708 18.157 4.06406C17.3592 3.28406 16.4186 2.66498 15.3867 2.24062C14.3133 1.79531 13.1742 1.57031 12 1.57031C10.8258 1.57031 9.68672 1.79531 8.61328 2.23828C7.575 2.66719 6.64453 3.28125 5.84297 4.06172C5.04826 4.83517 4.41215 5.7563 3.97031 6.77344C3.51328 7.82812 3.28125 8.94844 3.28125 10.1016C3.28125 11.7563 3.67734 13.4039 4.45547 14.993C5.08125 16.2703 5.95547 17.5148 7.05703 18.6984C8.93906 20.7188 10.9125 21.9539 11.4727 22.2844C11.6317 22.3783 11.813 22.4277 11.9977 22.4273C12.1805 22.4273 12.3609 22.3805 12.5227 22.2844C13.0828 21.9539 15.0563 20.7188 16.9383 18.6984C18.0398 17.5172 18.9141 16.2703 19.5398 14.993C20.3227 13.4063 20.7188 11.7609 20.7188 10.1039C20.7188 8.95078 20.4867 7.83047 20.0297 6.77578ZM12 20.6297C10.4555 19.6477 4.96875 15.7594 4.96875 10.1039C4.96875 8.27813 5.69766 6.5625 7.02188 5.26875C8.35078 3.97266 10.118 3.25781 12 3.25781C13.882 3.25781 15.6492 3.97266 16.9781 5.27109C18.3023 6.5625 19.0312 8.27813 19.0312 10.1039C19.0312 15.7594 13.5445 19.6477 12 20.6297Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.40625H15.2812C15.3844 9.40625 15.4688 9.49062 15.4688 9.59375V10.7188C15.4688 10.8219 15.3844 10.9062 15.2812 10.9062H12.75V13.4375C12.75 13.5406 12.6656 13.625 12.5625 13.625H11.4375C11.3344 13.625 11.25 13.5406 11.25 13.4375V10.9062H8.71875C8.61562 10.9062 8.53125 10.8219 8.53125 10.7188V9.59375C8.53125 9.49062 8.61562 9.40625 8.71875 9.40625H11.25V6.875C11.25 6.77187 11.3344 6.6875 11.4375 6.6875H12.5625C12.6656 6.6875 12.75 6.77187 12.75 6.875V9.40625Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPoint);
export default __webpack_public_path__ + "static/media/add-point.e920059c3878d52afed708797c24adab.svg";
export { ForwardRef as ReactComponent };